import { render } from "./CustomTopicModelEditor.vue?vue&type=template&id=4fc59c5e"
import script from "./CustomTopicModelEditor.vue?vue&type=script&lang=js"
export * from "./CustomTopicModelEditor.vue?vue&type=script&lang=js"

import "./CustomTopicModelEditor.vue?vue&type=style&index=0&id=4fc59c5e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__